import React from 'react';
import { SearchResults as SearchResultsLegacy } from './SearchResultsLegacy';
import { SearchResultsWithAtlassianApps } from './SearchResultsWithAtlassianApps';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Entry point for Search Results
 * Routes to either legacy or new UI based on experiment flag
 */
export function SearchResults(_ref) {
  let {
    searchInputRef,
    gridProps,
    isSearchQueryActive,
    onSortOptionSelect,
    areFiltersActive,
    handleClearAllFilters,
    selectedSortKey,
    analyticsFilters,
    isAppInstalled,
    selectedHostingFilter,
    useAtlassianAppsExperimentNewUI = false,
    cloudId
  } = _ref;
  return useAtlassianAppsExperimentNewUI ? /*#__PURE__*/_jsx(SearchResultsWithAtlassianApps, {
    searchInputRef: searchInputRef,
    gridProps: gridProps,
    isSearchQueryActive: isSearchQueryActive,
    areFiltersActive: areFiltersActive,
    handleClearAllFilters: handleClearAllFilters,
    analyticsFilters: analyticsFilters,
    selectedHostingFilter: selectedHostingFilter,
    cloudId: cloudId
  }) : /*#__PURE__*/_jsx(SearchResultsLegacy, {
    searchInputRef: searchInputRef,
    gridProps: gridProps,
    isSearchQueryActive: isSearchQueryActive,
    onSortOptionSelect: onSortOptionSelect,
    areFiltersActive: areFiltersActive,
    handleClearAllFilters: handleClearAllFilters,
    selectedSortKey: selectedSortKey,
    analyticsFilters: analyticsFilters,
    isAppInstalled: isAppInstalled,
    selectedHostingFilter: selectedHostingFilter
  });
}